import React, { useState } from 'react';
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
  ZoomableGroup
} from "react-simple-maps";
import './WorldMap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';

// Remplacer cette ligne :0const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

// Par celle-ci :
const geoUrl = "/data/countries-110m.json";

const markers = [
  { coordinates: [2.3522, 48.8566], name: "Paris" },
  { coordinates: [-74.006, 40.7128], name: "New York" },
  { coordinates: [121.4737, 31.2304], name: "Shanghai" },
  { coordinates: [139.6503, 35.6762], name: "Tokyo" },
  { coordinates: [55.2708, 25.2048], name: "Dubai" }
];

const WorldMap = () => {
  const [position, setPosition] = useState({ coordinates: [0, 30], zoom: 1 });

  function handleZoomIn() {
    if (position.zoom >= 4) return;
    setPosition(pos => ({ ...pos, zoom: pos.zoom * 1.5 }));
  }

  function handleZoomOut() {
    if (position.zoom <= 1) return;
    setPosition(pos => ({ ...pos, zoom: pos.zoom / 1.5 }));
  }

  return (
    <section className="world-map-section py-2">
        <div className="map-container" style={{ width: "100%", height: "500px" }}>
          <div className="controls">
            <button onClick={handleZoomIn}>
              
            <FontAwesomeIcon icon={faPlus} />
            </button>
            <button onClick={handleZoomOut}>
              <FontAwesomeIcon icon={faMinus} />
            </button>
          </div>
          <ComposableMap
            projection="geoMercator"
            projectionConfig={{
              scale: 100
            }}
            style={{
              width: "100%",
              height: "100%"
            }}
          >
            <ZoomableGroup
              center={position.coordinates}
              zoom={position.zoom}
              onMoveEnd={({ coordinates, zoom }) => setPosition({ coordinates, zoom })}
            >
              <Geographies geography={geoUrl}>
                {({ geographies }) =>
                  geographies.map((geo) => (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      fill="#E4E5E6"
                      stroke="#D6D6DA"
                      style={{
                        default: {
                          fill: "#E4E5E6",
                          outline: "none"
                        },
                        hover: {
                          fill: "#0d6efd",
                          outline: "none",
                          transition: "fill 0.3s ease-out"
                        }
                      }}
                    />
                  ))
                }
              </Geographies>
            </ZoomableGroup>
          </ComposableMap>
        </div>
    </section>
  );
};

export default WorldMap;